// extracted by mini-css-extract-plugin
module.exports = {"notification":"s_notification__16fWB","info":"s_info__24-X7","success":"s_success__1h8Ni","warning":"s_warning__1fZZ7","error":"s_error__2LilV","close":"s_close__3GwcL"};